import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AdditionalServicesActionCreator, FrameworkActionCreator, QuickTimesActionCreator } from 'src/store/states';
import AdditionalService from 'src/components/AdditionalServices/AdditionalService/AdditionalService';

const mapStateToProps = (state: IStoreState) => ({
    weOwes: state.AdditionalServices.allServices.weOwes,
    recom: state.AdditionalServices.allServices.recom,
    recalls: state.AdditionalServices.recallData.recalls,
    maintContracts: state.AdditionalServices.maintContractData.maintContracts,
    inquiryInvoked: state.AdditionalServices.allServices.inquiryInvoked,
    inquiryReturned: state.AdditionalServices.recallData.inquiryReturned,
    inquiryError: state.AdditionalServices.recallData.inquiryError,
    MCReturned: state.AdditionalServices.maintContractData.MCReturned,
    MCError: state.AdditionalServices.maintContractData.MCError,
    specData: state.Specs.specs,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    apptCust: state.Appointment.ApptCust,
    theme: state.Framework.theme,
    profile: state.Framework.specProfile,
    appointment: state.Appointment.Appointment,
    quickTimes: state.QuickTimes.quickTimes,
    checkedRecalls: state.AdditionalServices.checkedRecalls,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    waitOnMC: state.Framework.waitOnMC,
    waitOnRecall: state.Framework.waitOnRecall,
    noAutoRecall: state.Framework.noAutoRecall,
});

const mapDispatchToProps = {
    getRecalls: AdditionalServicesActionCreator.GetRecalls,
    setWaitOnRecall: FrameworkActionCreator.SetWaitOnRecall,
    setNoAutoRecall: FrameworkActionCreator.SetNoAutoRecall,
    getQuickTimes: QuickTimesActionCreator.GetQuickTimes,
    getMaintContracts: AdditionalServicesActionCreator.GetMaintContracts,
    setWaitOnMC: FrameworkActionCreator.SetWaitOnMC,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdditionalService);